import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={40} height={40} rx={20} fill={props.bgColor || "white"} />
    <Path
      d="M15.7998 25.1993V28.1984L19.6406 25.3194L19.7998 25.1993H27.2002V26.4005H20.1992L15.5596 29.88C15.3778 30.0163 15.1348 30.0383 14.9316 29.9366C14.7284 29.8349 14.5996 29.627 14.5996 29.3995V26.4005H12.7998V25.1993H15.7998ZM11 24.5997V13.8008C11 12.8053 11.8053 12.0001 12.7998 12V13.2012C12.5087 13.2013 12.2675 13.4061 12.2119 13.6797L12.2002 13.8008V24.5997C12.2002 24.9312 12.4673 25.1992 12.7998 25.1993V26.4005L12.6162 26.3907C11.7081 26.2988 11 25.5331 11 24.5997ZM27.7998 24.5997V13.8008C27.7998 13.4692 27.5327 13.2013 27.2002 13.2012V12C28.1326 12.0001 28.8982 12.7075 28.9902 13.6162L29 13.8008V24.5997C29 25.5952 28.1947 26.4004 27.2002 26.4005V25.1993C27.5327 25.1992 27.7998 24.9312 27.7998 24.5997ZM16.4004 20.3995V21.6007H15.7998V20.3995H16.4004ZM21.2002 20.3995V21.6007H16.4004V20.3995H21.2002ZM21.7998 20.3995V21.6007H21.2002V20.3995H21.7998ZM16.4004 16.7998V18.001H15.7998V16.7998H16.4004ZM23.5996 16.7998V18.001H16.4004V16.7998H23.5996ZM24.2002 16.7998V18.001H23.5996V16.7998H24.2002ZM27.2002 12V13.2012H12.7998V12H27.2002Z"
      fill={props.color || "#00813B"}
    />
  </Svg>
);
export default SVGComponent;
